import React from "react";
import Modal from "./Modal";
import SecondaryButton from "../components/Buttons/SecondaryButton";
import LoadingIcons from "react-loading-icons";

interface Member {
  id: string;
  user_id: string | null;
  email: string;
  name?: string;
  role: string;
  status: string;
  created_at: string;
}

interface RemoveMemberModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  removingMember: Member | null;
  removeLoading: boolean;
  removeError: string | null;
  onRemoveMember: () => void;
}

const RemoveMemberModal: React.FC<RemoveMemberModalProps> = ({
  isOpen,
  setIsOpen,
  removingMember,
  removeLoading,
  removeError,
  onRemoveMember,
}) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="w-full">
        <h3 className="text-base font-semibold tracking-tight text-gray-900 mb-0.5">
          Remove member
        </h3>
        <p className="text-sm text-gray-500 mb-5">
          This action cannot be undone.
        </p>

        {removeError && (
          <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2 mb-4">
            {removeError}
          </p>
        )}

        {removingMember && (
          <p className="text-sm text-gray-600 mb-5">
            Are you sure you want to remove{" "}
            <span className="font-medium text-gray-900">
              {removingMember.name || removingMember.email}
            </span>{" "}
            from this organisation?
          </p>
        )}

        <div className="flex gap-2">
          <SecondaryButton
            type="button"
            onClick={() => setIsOpen(false)}
            disabled={removeLoading}
            className="flex-1"
          >
            Cancel
          </SecondaryButton>
          <button
            type="button"
            onClick={onRemoveMember}
            disabled={removeLoading}
            className="flex-1 h-9 px-4 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {removeLoading ? (
              <span className="flex items-center justify-center gap-2">
                <LoadingIcons.TailSpin stroke="#fff" width="16" height="16" />
                Removing...
              </span>
            ) : (
              "Remove member"
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveMemberModal;
